import { extendLocale } from '@antv/s2';
import { Locale } from '@antv/s2-shared';

extendLocale(Locale);
